export const buildVersion = { buildVersion: 'build #397', buildDate: '2026-11-05T09:15:36.409+0100' };